import gql from 'graphql-tag'

export const QUERY_FEDERATIVE_UNITS = gql`
  {
    geolocationTree {
      countries {
        id
        name
        federative_units {
          id
          name
        }
      }
    }
  }
`

export const QUERY_CITIES = gql`
  {
    geolocationTree {
      countries {
        id
        name
        federative_units {
          id
          name
          cities {
            id
            name
          }
        }
      }
    }
  }
`

export const QUERY_NEIGHBORHOODS = gql`
  {
    geolocationTree {
      countries {
        id
        name
        federative_units {
          id
          name
          cities {
            id
            name
            neighborhoods {
              id
              name
            }
          }
        }
      }
    }
  }
`
